import type { IconProps } from '../types/IconProps.ts';
export const SwapHorizontal: IconProps = {
    name: 'SwapHorizontal',
    children: [
        `<path d="M8 3 4.13 6.8c-.17.11-.17.29 0 .4L8 11M6 7h14M16 13l3.65 3.65c.2.2.2.5 0 .7L16 21M4 17h14" />`,
    ]
};